// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D6BO","buttons":"styles_buttons__9mLyD"};